/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SavedViewDetails } from './SavedViewDetails';
import {
    SavedViewDetailsFromJSON,
    SavedViewDetailsFromJSONTyped,
    SavedViewDetailsToJSON,
} from './SavedViewDetails';

/**
 * 
 * @export
 * @interface ListSavedViewsResponse
 */
export interface ListSavedViewsResponse {
    /**
     * 
     * @type {Array<SavedViewDetails>}
     * @memberof ListSavedViewsResponse
     */
    savedViews: Array<SavedViewDetails>;
}

/**
 * Check if a given object implements the ListSavedViewsResponse interface.
 */
export function instanceOfListSavedViewsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "savedViews" in value;

    return isInstance;
}

export function ListSavedViewsResponseFromJSON(json: any): ListSavedViewsResponse {
    return ListSavedViewsResponseFromJSONTyped(json, false);
}

export function ListSavedViewsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSavedViewsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'savedViews': ((json['saved_views'] as Array<any>).map(SavedViewDetailsFromJSON)),
    };
}

export function ListSavedViewsResponseToJSON(value?: ListSavedViewsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'saved_views': ((value.savedViews as Array<any>).map(SavedViewDetailsToJSON)),
    };
}

